import { Dialog } from "@headlessui/react";
import ic_close from "../../assets/icons/ic_close.svg";

import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  BlackTextLinearGradient,
  WhiteLinearGradient,
} from "../../utils/Utils";
import CustomDialog from "../basic/Dialog";
import ic_facebook from "../../assets/icons/ic_facebook.svg";
import ic_whatsapp from "../../assets/icons/ic_whatsapp.svg";
import ic_twitter from "../../assets/icons/ic_twitter.svg";
import { toast } from "react-toastify";
import IconButton from "../basic/IconButton";
import { Icon } from "@iconify/react";
import { useAppContext } from "../../context/AppContext";

function ShareDialog({ show, close, shareLink, shareMessage }) {
  const appState = useAppContext();
  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel
        className={`w-full max-w-3xl dark:text-white transform overflow-hidden rounded-2xl text-left align-middle shadow-xl transition-all`}
      >
        <div
          className={`${WhiteLinearGradient} px-6 md:px-16 py-10 rounded-lg w-full flex flex-col space-y-5 `}
        >
          <div
            className={`absolute top-0 right-0 mr-5 flex mt-4 p-1 rounded-full ${WhiteLinearGradient}`}
          >
            <button type="button" className="rounded-md " onClick={close}>
              <Icon
                icon="carbon:close"
                color={appState.state.darkMode ? "#fff" : "#000"}
                className="h-6 w-6"
              />
            </button>
          </div>
          <p
            className={`font-medium text-3xl text-center ${BlackTextLinearGradient}`}
          >
            Share
          </p>
          <div className="flex w-full flex-row space-x-6 justify-center items-center">
            <WhatsappShareButton
              url={shareLink}
              title={shareMessage}
              className="flex flex-col items-center"
            >
              <img src={ic_whatsapp} className="h-12 w-12" />
              <p>Whatsapp</p>
            </WhatsappShareButton>
            <FacebookShareButton
              url={shareLink}
              quote={shareMessage}
              className="flex flex-col items-center"
            >
              <img src={ic_facebook} className="h-12 w-12" />
              <p>Facebook</p>
            </FacebookShareButton>
            <TwitterShareButton
              url={shareLink}
              title={shareMessage}
              className="flex flex-col items-center"
            >
              <img src={ic_twitter} className="h-12 w-12" />
              <p>Twitter</p>
            </TwitterShareButton>
          </div>
          {/* <div className="flex flex-col overflow-hidden md:flex-row items-center border-2 p-3 rounded-lg border-primary-extraLightBlue">
            <p className="md:flex md:flex-1 w-full break-words">{shareLink}</p>
            <p
              className="text-primary-blue font-medium hover:cursor-pointer"
              onClick={() => {
                navigator.clipboard.writeText(shareLink);

                toast("Link copied to clipboard");
              }}
            >
              COPY
            </p>
          </div> */}
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

export default ShareDialog;
